import { isEmpty } from 'lodash';
import L from 'leaflet';

import { getLandingBearing } from '../../api/Missions/mission-operations';
import { bearingPathStyle } from '../client/waypoint-style-chooser';

import setLandingBearing from './setLandingBearing';
import moveLandingBearing from './moveLandingBearing';

/**
 * Shows the landing bearing in the map.
 *
 * @param {*} arg - The object argument.
 * @param {boolean} arg.mission - The mission object.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {?object} [arg.landingBearingLayer] - The layer with the landing bearing.
 * @param {?Function} [arg.getCurrentMapState] - A function that gets the current variables
 * needed from the map component.
 * @param {boolean} [arg.isUpdate=false] - Flag to determine if we are doing an update.
 */
const showLandingBearing = ({
  mission,
  landingBearingLayer,
  leafletMap,
  getCurrentMapState,
  isUpdate = false
}) => {
  let newLandingBearingLayer = '';
  if (!isUpdate) {
    newLandingBearingLayer = L.geoJSON(null, bearingPathStyle).addTo(leafletMap);
    leafletMap.on('click', event =>
      setLandingBearing({
        event,
        getCurrentMapState
      })
    );

    leafletMap.on('mousemove', event =>
      moveLandingBearing({
        event,
        getCurrentMapState
      })
    );
  } else {
    newLandingBearingLayer = landingBearingLayer;
    newLandingBearingLayer.clearLayers();
  }
  const landingBearing = getLandingBearing(mission);
  if (!isEmpty(landingBearing)) {
    newLandingBearingLayer.addData(landingBearing);
  }
  return newLandingBearingLayer;
};

export default showLandingBearing;
